import React from 'react';
import { 
  Box, 
  TablePagination, 
  useTheme,
  useMediaQuery
} from '@mui/material';

const PaginationControls = ({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [50, 100, 200, 500]
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box 
      sx={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 1 : 0,
        py: isMobile ? 1 : 0
      }}
    >

      {/* Pagination Controls */}
      <TablePagination
        component="div"
        count={count}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        sx={{ 
          flexGrow: 1,
          width: isMobile ? '100%' : 'auto',
          '& .MuiTablePagination-toolbar': {
            minHeight: isMobile ? 'auto' : 52,
            paddingLeft: isMobile ? 1 : 2,
            paddingRight: isMobile ? 1 : 2,
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: isMobile ? 'stretch' : 'center',
            gap: isMobile ? 1 : 0
          },
          '& .MuiTablePagination-spacer': {
            display: isMobile ? 'none' : 'flex'
          },
          '& .MuiTablePagination-displayedRows': {
            margin: isMobile ? '0' : '0 32px 0 0',
            fontSize: isTablet ? '0.875rem' : '0.875rem',
            textAlign: isMobile ? 'center' : 'left'
          },
          '& .MuiTablePagination-selectLabel': {
            margin: isMobile ? '0' : '0 8px 0 0',
            fontSize: isTablet ? '0.875rem' : '0.875rem'
          },
          '& .MuiTablePagination-select': {
            fontSize: isTablet ? '0.875rem' : '0.875rem'
          },
          '& .MuiTablePagination-actions': {
            marginLeft: isMobile ? 0 : 8,
            '& button': {
              padding: isMobile ? '8px' : '12px'
            }
          }
        }}
        labelRowsPerPage={isMobile ? "Rows:" : "Rows per page:"}
        labelDisplayedRows={({ from, to, count }) => 
          isMobile ? `${from}-${to} of ${count}` : `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
        }
        showFirstButton={!isMobile}
        showLastButton={!isMobile}
      />
    </Box>
  );
};

export default PaginationControls;